var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbar = document.querySelector('.adm-nav-sticky');
var scrollEffectHeader = document.querySelector('header');
const mobileFilterContainerFeat = document.querySelector('.adm-div-c5-filters-side-menu');
window.addEventListener('scroll', function () {
    didScroll = true;
    checkSearchBoxStatus();
});

setInterval(function () {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var navbarHeight = navbar?.offsetHeight;
    var st = window.pageYOffset;

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta)
        return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight && !navbar.matches(".adm-nav-sticky:hover") && !navbar.matches(".adm-nav-sticky:focus-within")) {
        // Scroll Down
        if (navbar) navbar.style.top = "-" + navbarHeight + "px";
        if (mobileFilterContainerFeat) {
            mobileFilterContainerFeat.style.top = "0";
            mobileFilterContainerFeat.style.height = "";
        }
    } else {
        // Scroll Up
        scrollUp(st);
    }

    lastScrollTop = st;
}

function scrollUp(st) {
    if (st + window.innerHeight < document.body.scrollHeight) {
        if (navbar) navbar.style.top = '0';
        if (mobileFilterContainerFeat) {
            mobileFilterContainerFeat.style.top = "73px";
            mobileFilterContainerFeat.style.height = "calc(100vh - 73px)";
        }
    }
}

navbar?.addEventListener("focusin", () => {
    if (navbar) navbar.style.top = '0';
    if (mobileFilterContainerFeat) {
        mobileFilterContainerFeat.style.top = "73px";
        mobileFilterContainerFeat.style.height = "calc(100vh - 73px)";
    }
})

let searchboxBackgroundPos = window.scrollY;
let isSearchBoxActive = false;

const checkSearchBoxStatus = () => {
  if (scrollEffectHeader.classList.contains("scroll-listener") && !isSearchBoxActive) {
    searchboxBackgroundPos = window.scrollY;
    isSearchBoxActive = true;
    searchBoxDisableScroll();
  } else if (!scrollEffectHeader.classList.contains("scroll-listener") && isSearchBoxActive) {
    isSearchBoxActive = false;
    searchBoxEnableScroll();
  }
}

const scrollEventSearchbox = function () {
  if (scrollEffectHeader?.classList.contains("scroll-listener")) {
    if (scrollEffectHeader?.classList.contains("search-results-page")) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, searchboxBackgroundPos);
    }
  }
}

const searchBoxDisableScroll = () => {
  window.addEventListener("scroll", scrollEventSearchbox, false)
}

const searchBoxEnableScroll = () => {
  window.removeEventListener("scroll", scrollEventSearchbox, false)
}